import React from 'react'
import Link from 'gatsby-link'
import Logo from '../assets/logo-with-address.svg'
import LeftCorner from '../assets/left-corner.svg'
import RightCorner from '../assets/right-corner.svg'
import Countdown from 'react-countdown-to-future-date'

const IndexPage = () => (
  <div style={{ zIndex: 1000 }}>
    <div
      style={{
        margin: 'auto',
        width: '50%',
        textAlign: 'center',
        color: 'white',
      }}
    >
      <h2 style={{ fontWeight: 'bold', fontSize: '3em' }}>
        Happy Birthday, Maria!
      </h2>
      <h2 style={{ fontWeight: 'bold', fontSize: '2em' }}>
        Party starts at 12:00
      </h2>
      <h4>
        <Countdown givenDate={'2018-08-20T12:00'} />
      </h4>
      <h4>Monday August 20th</h4>
      <h4>Waterland, Tagarades</h4>
      <h4>
        {' '}
        <a href="https://goo.gl/maps/2wvn4FoGwRq" style={{ color: 'white' }}>
          <img
            src="/maps.png"
            width="30"
            height="30"
            style={{ display: 'inline', marginBottom: 0 }}
          />
          https://goo.gl/maps/TyHiQbPMBCJ2
        </a>
      </h4>

      <h4>
        {' '}
        <a href="/invitation.mp4" style={{ color: 'darkblue' }}>
          Invitation video
        </a>
      </h4>
      <div>
        <video width="100%" controls>
          <source src="/invitation.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js